import { DISPLAY_LIST_TYPE } from '../classes/Const';
import Task from '../classes/Task';
import Member from '../classes/Member';
import Project from '../classes/Project';

const state = {
	display_list_type: DISPLAY_LIST_TYPE.MEMBER,
	target_member_code: null,
	target_project_code: null,
};

const getters = {
	display_list: function (state, getters, rootState, rootGetters) {
		return (code) => {
			let display_tasks = new Array();
			rootState.data.data_task.forEach( t => {
				let display_schedueles = new Array();
				t.schedules.forEach( s => {
					if (s.isOverlapOneDay(rootGetters.currentDate)) {
						display_schedueles.push(s);
					}
				});
				if (display_schedueles.length > 0) {
					display_tasks.push(new Task({
						code: t.code,
						name: t.name,
						schedules: display_schedueles,
						project_code: t.project_code,
						member_code: t.member_code,
						remarks: t.remarks,
					}));
				}
			});
			if (display_tasks.length == 0)
				return display_tasks;

			if (getters.isDisplayMemberList) {
				let list_member = rootState.master.data_member.map( m => {
					let tasks = display_tasks.filter(t => t.member_code == m.code);
					let schedules = [];
					tasks.forEach(t => {
						t.schedules.forEach(s => {
							schedules.push(s);
						});
					});
					return new Member(Object.assign(Object.assign({}, m), {
						children: tasks,
						schedules: schedules,
					}));
				});
				return list_member.filter(m => { return m.code == code })[0];
			} else {
				let project_list = {};
				display_tasks.forEach( t => {
					if (t.project_code) {
						if (project_list[t.project_code] === undefined) {
							let project = rootGetters.project(t.project_code);
							if (project !== undefined) {
								project_list[t.project_code] = new Project(Object.assign({}, project));
								project_list[t.project_code].children.push(t);
							}
						} else {
							project_list[t.project_code].children.push(t);
						}
					}
				});
				return Object.values(project_list).filter(p => { return p.code == code })[0];
			}
		}
	},
	isDisplayMemberList: function(state) {
		return state.display_list_type === DISPLAY_LIST_TYPE.MEMBER;
	},
	targetMember: function(state, getters, rootState, rootGetters) {
		let code = state.target_member_code;
		if (!code)
			code = rootGetters.loginUser.code;
		return code;
	},
	targetProject: function(state) {
		return state.target_project_code;
	},
};

const mutations = {
	initState: function() {
		state.display_list_type = DISPLAY_LIST_TYPE.MEMBER;
	},
	setDisplayListType: function(state, value) {
		state.display_list_type = value;
	},
	setTargetMember: function(state, code) {
		state.target_member_code = code;
	},
	setTargetProject: function(state, code) {
		state.target_project_code = code;
	},
};

const actions = {
	setDisplayListTypeMember: function(store) {
		store.commit('setDisplayListType', DISPLAY_LIST_TYPE.MEMBER);
	},
	setDisplayListTypeProject: function(store) {
		store.commit('setDisplayListType', DISPLAY_LIST_TYPE.PROJECT);
	},
};

export default {
	name: 'list',
	namespaced: true,
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions,
};
